<script setup>
import {ref,onMounted} from 'vue'
// import 'github-markdown-css'
import { pageConfig } from './assets/config.js';
import MarkdownRender from './components/MarkdownRender.vue'
 
let query = ref(null) 
const params = ref(null)

onMounted(() => {
  params.value = getUrlKey('param')

  const config = pageConfig[params.value] || {};
  query.value = config.query || '';
  document.title = config.pageTitle || '';
});

const getUrlKey = (name) => {
  const url = new URL(window.location.href);
  const paramValue = url.searchParams.get(name);
  return paramValue ? decodeURIComponent(paramValue.replace(/\+/g, '%20')) : null;
}

</script>

<template>
  <div class="markdown-body">
    <markdown-render :name="query"/>
  </div>
</template>

<style scoped>
 @import url(./assets/github-markdown.css);
</style>
